
  <div class="hotel-map-info">
    <div class="hotel-map-info__container">
      <div class="hotel-map-info__container__info">

        <a [href]="detailUrl" target="_blank" (click)="trackEvent()">

          <p class="hotel-map-info__container__info__hotel-title">{{ hotelSelected.name }}</p>

          <div class="hotel-map-info__container__info__stars">
            @if (hotelSelected?.isHomestays) {
              <span class="hotel-map-info__container__info__temporary">
                Alquiler temporario
              </span>
            } @else {
              @if (hotelSelected?.stars != 0) {
                <mb-stars-rating [rating]="hotelSelected?.stars"></mb-stars-rating>
              }
            }
            @if (hotelSelected?.amenities?.length > 0) {
              @for (iconName of hotelSelected.amenities | slice: 0:4; track iconName) {
                <ng-template #tooltip>
                  <div class="text__amenity">{{ $any(iconName).description }}</div>
                </ng-template>
                <mb-icon class="icon__amenity" [mb-tooltip]="tooltip" mbTooltipColor="dark"
                  mbTooltipPosition="below" [icon]="$any(iconName).icon"></mb-icon>
              }
            }
          </div>

          @if (hotelSelected?.meal_plan) {
            @if (getMealPlanIcon(hotelSelected?.meal_plan?.code); as icon) {
              <mb-badge class="hotel-map-info__container__info__meal-plan"
              size="small"
              color="light">
                {{ hotelSelected.meal_plan.description }}
              </mb-badge>
            }
          }

          @if (getPaymentBadgeText(hotelSelected); as text) {
            <mb-badge class="hotel-map-info__container__info__refundable" size="small">
              {{ text | slice: 0:20 }}
              @if (text.length > 20) { ... }
            </mb-badge>
          }
        </a>

        <div class="hotel-map-info__container__info__price-container" [ngClass]="{'no-discount':hotelSelected?.discount_percentage < 5}">
         @if (hotelSelected?.discount_percentage >= 5) {
           <div class="price__discount">
             <mb-advice [align]="'right'" size="small" color="success" class="price__gift">
               {{ hotelSelected?.discount_percentage }}% OFF
             </mb-advice>
             <div class="price__without-discount">
               <strong><s>{{ currencyLabel }}{{ hotelSelected?.price_without_discount | Currency }}</s></strong>
             </div>
           </div>
         }

          <div class="hotel-map-info__container__info__price-container__price-night" [ngClass]="{'discount':hotelSelected?.discount_percentage >= 5}">
            <span class="hotel-map-info__container__info__price-text">Precio por noche</span>
            @if (hotelSelected?.price && !isAlliance) {
              <p class="price price--lg">
                <span class="price__currency">{{currencyLabel}}&nbsp;</span>
                <span class="price__amount">{{ priceToDisplay | Currency }}</span>
              </p>
            }
          </div>
          <div class="hotel-map-info__container__info__price-container__price-tax-container">
            @if (isAlliance) {
              <am-rewards-pricing [price]="priceToDisplay"></am-rewards-pricing>
            }
            <div class="tax-info">
              @if (getTaxInfoText(); as taxText) {
                <span>{{ taxText }}</span>
              }
              <mb-icon icon="info" class="icon-focus" (click)="expandBreakdown()"></mb-icon>
            </div>
            <div class="total-price__wrapper">
              <p class="total-price">Precio total</p>
              <p class="total-price">{{currencyLabel}} {{ hotelSelected?.total | Currency }}</p>
            </div>
          </div>

          <am-pricing-expandable class="hotel-map-info__container__info__price-container__price-tax-container__expandable" [rateId]="pricingKey" [fop]="hotelSelected?.payment_methods[0].code"
          [currencyCode]="hotelSelected?.currency" #pricingExpandable></am-pricing-expandable>
        </div>
      </div>
    </div>
  </div>
